exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.common_page[data-v-87836d2c]{text-align:center;padding:.4rem 0;margin-bottom:.2rem\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/oldCode/components/common/page.vue"],"names":[],"mappings":";AACA,8BAA8B,kBAAkB,gBAAgB,mBAAmB;CAClF","file":"page.vue","sourcesContent":["\n.common_page[data-v-87836d2c]{text-align:center;padding:.4rem 0;margin-bottom:.2rem\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87836d2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/style-rem-loader??ref--1!./src/oldCode/components/common/page.vue
// module id = 1323
// module chunks = 2